import React from 'react';
import { useLang } from '../i18n/LanguageContext';

const departments = [
  ['Water Resources Department', 'நீர்வளத் துறை'],
  ['Rural Development and Panchayat Raj', 'ஊரக வளர்ச்சி மற்றும் ஊராட்சித் துறை'],
  ['Town Panchayats', 'பேரூராட்சிகள் இயக்குநரகம்'],
  ['Greater Chennai Corporation', 'பெருநகர சென்னை மாநகராட்சி'],
  ['Municipal Administration', 'நகராட்சி நிர்வாக இயக்குநரகம்'],
  ['Hindu Religious & Charitable Endowments', 'இந்து சமய அறநிலையத் துறை'],
  ['Environment, Climate Change & Forest', 'சுற்றுச்சூழல், காலநிலை மாற்றம் மற்றும் வனத் துறை'],
];

const LandingPageFooter = () => {
  const { tr } = useLang();

  return (
    <footer className="bg-brand-900 border-t-4 border-brand-accent text-white">
      <div className="container mx-auto px-8 py-12">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-10">
          {/* Portal */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-5">
              <img src="/images/tnlogo.png" alt="Government of Tamil Nadu" className="w-14 h-14 mr-4 bg-white p-1.5" />
              <div>
                <h3 className="text-2xl font-semibold">ஏரி இணையதளம்</h3>
                <p className="text-brand-100 text-sm">{tr('ERI Website · Government of Tamil Nadu', 'தமிழ்நாடு அரசு')}</p>
              </div>
            </div>
            <p className="text-brand-100 leading-relaxed">
              {tr(
                'Website for Restoration of Water Bodies with the Participation of Volunteers and Issuance of No Objection Certificates (NOC).',
                'தன்னார்வலர்களின் பங்களிப்புடன் நீர்நிலைகளைப் புனரமைத்தல் மற்றும் தடையின்மைச் சான்று (NOC) வழங்குவதற்கான இணையதளம்.'
              )}
            </p>
            <p className="mt-3 text-sm font-semibold text-brand-accent">
              {tr(
                'Protect Water Bodies • Promote Community Participation • Ensure Water Security',
                'நீர்நிலைகளைப் பாதுகாப்போம் • சமூகப் பங்கேற்பை ஊக்குவிப்போம் • நீர் வளப்பாதுகாப்பை உறுதி செய்வோம்'
              )}
            </p>
          </div>

          {/* Departments */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{tr('Stakeholder Departments', 'பங்குதாரர் துறைகள்')}</h4>
            <ul className="space-y-2">
              {departments.map(([en, ta]) => (
                <li key={en} className="text-brand-100 text-sm leading-relaxed">{tr(en, ta)}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{tr('Contact Us', 'தொடர்புக்கு')}</h4>
            <div className="space-y-4 text-sm">
              <div>
                <div className="text-brand-100">{tr('Email', 'மின்னஞ்சல்')}</div>
                <a href="mailto:noc@tnwater.gov.in" className="text-white hover:text-brand-accent">noc@tnwater.gov.in</a>
              </div>
              <div>
                <div className="text-brand-100">{tr('Address', 'முகவரி')}</div>
                <div className="text-white leading-relaxed">
                  {tr('Water Resources Department', 'நீர்வளத் துறை')}<br />
                  {tr('Secretariat, Chennai - 600009', 'தலைமைச் செயலகம், சென்னை - 600009')}<br />
                  {tr('Tamil Nadu, India', 'தமிழ்நாடு, இந்தியா')}
                </div>
              </div>
              <div>
                <div className="text-brand-100">{tr('Phone', 'தொலைபேசி')}</div>
                <a href="tel:+914428962500" className="text-white hover:text-brand-accent">+91 44 2896 2500</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 mt-10 pt-6 text-sm text-brand-100 text-center">
          © {new Date().getFullYear()} {tr('Government of Tamil Nadu. All rights reserved.', 'தமிழ்நாடு அரசு. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.')}
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
